import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import NavBar from '@components/NavBar';

import './Header.scss';

const Header: FC<{}> = () => {
    const navigate = useNavigate();
    const title = process.env.REACT_APP_TITLE || '';

    return (
        <header className="header">
            <div className="container-fluid">
                <div className="product-name" onClick={() => navigate('/dashboard')}>{title} ©</div>
                <NavBar />
            </div>
        </header>
    );
};

export default Header;
